/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can 
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 * ======================================================================== */

(function($) {

    $.resizeend = function(el, options){
      var base = this;
     
      base.$el = $(el);
      base.el = el;
     
      base.$el.data("resizeend", base);
      base.rtime = new Date(1, 1, 2000, 12,00,00);
      base.timeout = false;
      base.delta = 200;
     
      base.init = function(){
          base.options = $.extend({},$.resizeend.defaultOptions, options);
         
          if(base.options.runOnStart) base.options.onDragEnd();
         
          $(base.el).resize(function() {
             
              base.rtime = new Date();
              if (base.timeout === false) {
                  base.timeout = true;
                  setTimeout(base.resizeend, base.delta);
              }
          });
     
      };
      base.resizeend = function() {
          if (new Date() - base.rtime < base.delta) {
              setTimeout(base.resizeend, base.delta);
          } else {
              base.timeout = false;
              base.options.onDragEnd();
          }               
      };
     
      base.init();
  };

  $.resizeend.defaultOptions = {
      onDragEnd : function() {},
      runOnStart : false
  };

  $.fn.resizeend = function(options){
      return this.each(function(){
          (new $.resizeend(this, options));
      });
  };

  jQuery.fn.scrollOffset = function () {
      var win = $(window);
      var topSpace = this.offset().top - win.scrollTop();
      var bottomSpace = win.height() - this.height() - topSpace;
      var leftSpace = this.offset().left;
      var rightSpace = win.width() - this.width() - leftSpace;
      return { top: topSpace, bottom: bottomSpace, left: leftSpace, right: rightSpace };
  };   

  function isElementInViewport (el, verticaloffset) {
    var win = $(window);
    
    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();
    
    var bounds = el.offset();
    bounds.right = bounds.left + el.outerWidth();
    bounds.bottom = bounds.top + el.outerHeight();
    
    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
    
  }

  function viewport() {
    var e = window, a = 'inner';
    if (!('innerWidth' in window )) {
        a = 'client';
        e = document.documentElement || document.body;
    }
    return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
  }

  $.preloadImages = function() {
    for (var i = 0; i < arguments.length; i++) {
      $("<img />").attr("src", arguments[i]);
    }
  };

  function set_animation(el) {
    el.addClass('animated');
    if (el.hasClass('down')) {
      el.addClass('fadeInDown');
    } else if (el.hasClass('left')) {
      el.addClass('fadeInLeft');
    } else if (el.hasClass('right')) {
      el.addClass('fadeInRight');
    } else if (el.hasClass('in')) {
      el.addClass('fadeIn');
    } else if (el.hasClass('up')) {
      el.addClass('fadeInUp');
    } else if (el.hasClass('upLarge')) {
      el.addClass('fadeInUpLarge');
    } else if (el.hasClass('anim')) {
      el.get(0).play();
    }
  }
 
// Use this variable to set up the common and page specific functions. If you 
// rename this variable, you will also need to rename the namespace below.
var Roots = {
  
  /*
    Preload 
  */
  preload: {
    init: function() {
      $('.dropdown-toggle').on('click touch', function(){
        $('.dropdown-toggle').attr('href', '#');
        $(this).parent().toggleClass('active');
      });

      $('#nav-button').on('click', function() {
        $('header').toggleClass('open');
        $('#nav-button').toggleClass('open');
      });

      if ($(window).height() <= 750) {
        var bodyheight = $('.page-wrapper').innerHeight();
        $('header.side-nav').outerHeight(bodyheight).css({ 'position': 'absolute' });
      }

      $(window).on('resize', function() {
        if ($(window).height() <= 750) {
          var bodyheight = $('.page-wrapper').innerHeight();
          $('header.side-nav').outerHeight(bodyheight).css({ 'position': 'absolute' });
        } else {
          $('header.side-nav').height('').css({ 'position': '' });
        }
      });

      $('.featured-img').on('click',function(e) {
        if($(this).attr('data-target')){
          window.location.href = $(this).attr('data-target');
        }
      });
      
      $('.article-post').on('click',function(e) {
        if($(this).attr('data-target')){
          window.location.href = $(this).attr('data-target');
        }
      });

      $(window).on('scroll', function () {
        $('.scrolling').each(function() {
          if ( isElementInViewport($(this), 100) ) {
            $(this).removeClass('scrolling');
            set_animation($(this));
          }
        });
      });
    $('.scrolling').each(function() {
        if ( isElementInViewport($(this), 100) ) {
          $(this).removeClass('scrolling');
          set_animation($(this));
        }
      });
    }
  },
 
  /* 
    Front Page
  */
  home: {
    init: function() {
      $('.featured-img').on('click',function(e) {
        if($(this).attr('data-target')){
          window.location.href = $(this).attr('data-target');
        }
      });
    }
  },

  /* 
    Our Work Page
  */
  page_template_template_our_work: {
    init: function() {
      var i = 0;
      var contentHeight = [];
      var blockquoteHeight = [];
      $('.our-people-container > li').each(function() {
        contentHeight[i] = $(this).find('.content--bottom').outerHeight();
        i++;
      });

      $('.our-people-container > li:nth-child(2n)').each(function() {
        blockquoteHeight[i] = $(this).find('blockquote').height() + $(this).find('blockquote p').outerHeight()+14;
        i++;
      });

      $(window).on('resize', function() {
        contentHeight = [];
        i = 0;
        $('.content--bottom').removeClass('hide').css({ 'height': '' });
        $('.our-people-container > li').each(function() {
          var conbottom = $(this).find('.content--bottom');
          contentHeight[i] = conbottom.outerHeight();
          if (conbottom.hasClass('open')) {
            conbottom.css({ 'height': contentHeight[i] });
          }
          i++;
        });
        $('.content--bottom').addClass('hide');
      });

      $('.content--bottom').addClass('hide');
      $('blockquote').addClass('hide');
      
      $('.btn').on('click',function(e) {
        var listindex = $(this).parent().parent().index();
        var localContent = $(this).parent().find('.content--bottom');
        var localBlockquote = $(this).parent().find('blockquote');
        
        localContent.toggleClass('open');
        localBlockquote.toggleClass('open');
        $(this).toggleClass('open');
        
        if(localContent.hasClass('open')) {
          localContent.css({ 'height': contentHeight[listindex] });
          localBlockquote.css({ 'height': blockquoteHeight[listindex] });
        }
        else {
          localContent.css({ 'height': '0' });
          localBlockquote.css({ 'height': '' });
        }
      });
      
    }
  },

  /*
    Postload 
  */
  postload: {
    init: function() {
     
    }
  },

};

// The routing fires all common scripts, followed by the page specific scripts.
// Add additional events for more control over timing e.g. a finalize event
var UTIL = {
  fire: function(func, funcname, args) {
    var namespace = Roots;
    funcname = (funcname === undefined) ? 'init' : funcname;
    if (func !== '' && namespace[func] && typeof namespace[func][funcname] === 'function') {
      namespace[func][funcname](args);
    }
  },
  loadEvents: function() {
    UTIL.fire('preload');

    $.each(document.body.className.replace(/-/g, '_').split(/\s+/),function(i,classnm) {
      UTIL.fire(classnm);
    });

    UTIL.fire('postload');
  }
};

$(document).ready(UTIL.loadEvents);

})(jQuery);
